export default "__VITE_ASSET__BCxYSDgi__"